import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';
import {acquisitionTransition} from '../../../services/AcquisitionServices';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

export default function ForwardAcquisition(props) {
  const dispatch = useContext(DispatchContext);
  const {open, handleAction, acquisitionId} = props;

  const onSubmit = () => {
    acquisitionTransition('put', acquisitionId, {action: 'forward_to_admin'}).then(res => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Acquisition forward successfully'}
      });
      handleAction();
    });
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAction}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle align={'center'} color={'#616B88'} sx={{fontSize: 25}} className={'text-bold'}
                     fontWeight={700}>
          Forward to Admin
        </DialogTitle>
        <Box className={'common-divider'}/>
        <DialogContent sx={{width: 400}}>
          <Typography>
            Are you sure you want to forward this acquisition? By confirming, you forward the acquisition to the admin.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAction} variant={'outlined'}
                  color={'error'} className={'text-capitalize'}>
            Cancel
          </Button>
          <Button variant={'contained'} onClick={onSubmit} className={'text-capitalize'}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}